import React from 'react'

import { Textarea } from '@/components/ui/textarea'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import {
  selectLogHistoricalReferralState,
  updateLogData,
} from '@/redux/slices/logHistoricalReferral'

interface Props {
  className?: string
  disabled?: boolean
}

const SetCircumstances: React.FC<Props> = ({ className, disabled = false }) => {
  const dispatch = useAppDispatch()
  const referralLogHistoricalState = useAppSelector(
    selectLogHistoricalReferralState,
  )
  const formRef = React.createRef<HTMLFormElement>()

  function handleOnSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()

    dispatch(
      updateLogData({
        circumstances: event.currentTarget.circumstances.value,
      }),
    )
  }
  function handleInputChange() {
    formRef.current?.requestSubmit()
  }

  return (
    <div className={className}>
      <form ref={formRef} onSubmit={handleOnSubmit}>
        <Textarea
          disabled={disabled}
          placeholder="Add any notes about this referral..."
          defaultValue={referralLogHistoricalState.logData.circumstances}
          name="circumstances"
          rows={3}
          onBlur={handleInputChange}
        />
      </form>
    </div>
  )
}

export default SetCircumstances
